<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "PointCard"
}
</script>

<style scoped>

</style>